import {
  PLAYER_EPG_TRANSACTIONS_SHOW_EPG_TRANSACTIONS,
  PLAYER_EPG_TRANSACTIONS_HIDE_EPG_TRANSACTIONS,
} from '../../actions/epgTransactions/constants';

const initialState = {
  isOpen: false,
  data: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case PLAYER_EPG_TRANSACTIONS_SHOW_EPG_TRANSACTIONS:
      return { ...state, isOpen: true, data: action.payload };
    case PLAYER_EPG_TRANSACTIONS_HIDE_EPG_TRANSACTIONS:
      return { ...state, isOpen: false, data: null };
    default:
      return state;
  }
};
